import { render, staticRenderFns } from "./item_stats_value.vue?vue&type=template&id=4fe5a2dc"
import script from "./item_stats_value.vue?vue&type=script&lang=js"
export * from "./item_stats_value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports